import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router';
import InputTextField from 'components/common/InputTextField';

class ThemeTableRow extends Component {
    render() {
        const { columns = {}, deleteConfigRow, editConfigRow, index, isDisabled, item, single } = this.props;
        const columnKeys = !_.isEmpty(columns) ? _.keys(columns) : Object.keys(item);
        const firstColumnValue = _.get(item, [columnKeys[0]]);
        const secondColumnValue = _.get(item, [columnKeys[1]]);

        if (single) {
            return (
                <tr>
                    <td>
                        <input
                            disabled={isDisabled}
                            type="text"
                            value={item}
                            onChange={event => editConfigRow('nothign', index, event.target.value)}
                        />
                    </td>
                    <td>
                        <LinkIcon
                            disable={isDisabled}
                            onClick={() => deleteConfigRow(index)}
                            iconType="spark-icon-trash"
                        />
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td>
                    <InputTextField
                        disabled={isDisabled}
                        type="text"
                        value={firstColumnValue}
                        onChange={event => editConfigRow(columnKeys[0], index, event.target.value)}
                    />
                </td>
                <td>
                    <InputTextField
                        disabled={isDisabled}
                        type="text"
                        value={secondColumnValue}
                        onChange={event => editConfigRow(columnKeys[1], index, event.target.value)}
                    />
                </td>
                <td>
                    <LinkIcon disable={isDisabled} onClick={() => deleteConfigRow(index)} iconType="spark-icon-trash" />
                </td>
            </tr>
        );
    }
}

ThemeTableRow.propTypes = {
    columns: PropTypes.shape({}),
    deleteConfigRow: PropTypes.func.isRequired,
    editConfigRow: PropTypes.func.isRequired,
    index: PropTypes.number,
    isDisabled: PropTypes.bool,
    item: PropTypes.object,
    single: PropTypes.bool
};

class LinkIcon extends Component {
    render() {
        const icon = <i className={this.props.iconType + ' spark-icon--md'} />;
        if (!this.props.disable) {
            return (
                <a className="spark-margin-right-6" onClick={this.props.onClick}>
                    {icon}
                </a>
            );
        } else return icon;
    }
}

LinkIcon.propTypes = {
    iconType: PropTypes.string,
    disable: PropTypes.bool,
    onClick: PropTypes.func
};

export default withRouter(ThemeTableRow);



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TableRow.js